import { MasterCrudPage } from '@/components/MasterCrudPage.jsx';

export default function DepartmentsPage() {
  return (
    <MasterCrudPage
      title="Departments"
      description="Organizational departments"
      endpoint="/departments"
      queryKey={['departments']}
      fields={[
        { name: 'code', label: 'Code', required: true, placeholder: 'e.g. ENG' },
        { name: 'name', label: 'Name', required: true },
        { name: 'description', label: 'Description', type: 'textarea' },
      ]}
      columns={[
        { key: 'code', header: 'Code', sortable: true, className: 'font-mono' },
        { key: 'name', header: 'Name', sortable: true },
        { key: 'description', header: 'Description' },
      ]}
    />
  );
}
